module.exports = __webpack_public_path__ + "img/records-small-dark-green.538a2cf5.svg";